/*
 * Copyright (C) 2023 to Present Applause App Quality, Inc. All rights reserved.
 */

import { animate, style, transition } from '@angular/animations';

export const SlideAnimation = [
  transition(':enter', [
    style({ height: '0', overflow: 'hidden' }),
    animate('100ms', style({ height: '*' })),
  ]),
  transition(':leave', [
    style({ overflow: 'hidden' }),
    animate('50ms', style({ height: '0' }))
  ])
];
